<template>
  <div>
    <new-allMaintainQuartzJob showingPage="allMaintainQuartzJob"></new-allMaintainQuartzJob>
  </div>
</template>

<script>
import backgroundSupply from '../../../components/backgroundSupply.vue' 
/**
 *@ClassName:fullprojectAutoInspecRepoBGS
 *@Description:全项目自动巡检报事-后台补单
 *@author:宋莎
 *@Copyright:格众科技
 *@date:2020-04-21
 */
export default {
  components: {
    'new-allMaintainQuartzJob': backgroundSupply 
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {
  
},
}
</script>
<style lang='scss'>
 
</style>